import { render, staticRenderFns } from "./IAPDetails.vue?vue&type=template&id=9f490a12&"
import script from "./IAPDetails.vue?vue&type=script&lang=js&"
export * from "./IAPDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports